/*
 * @Description:
 * @Date: 2025-04-18 12:27:44
 * @LastEditTime: 2026-07-07 10:04:43
 * @FilePath: \admin_hilo\src\main.js
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import iView from "iview";
import i18n from "./libs/vuei18n.js";
import vueLoading from "./libs/loadingOverlay.js";
import "iview/dist/styles/iview.css";
import "@/css/index.less";
import http from "@/js/http.js";
import until from "@/js/until.js";
import dictionary from "@/js/dictionary.js";
import config from "@/config";
import store from "./store";
import "./plugins/video.js";
import utils from "app-info-parser/src/utils.js";

Vue.prototype.$http = http;
Vue.prototype.$config = config;
Vue.prototype.$dictionary = dictionary;
Vue.prototype.$selfGlobal = {
  $globalStore: store,
  $globalI18n: i18n,
  $globalRequestMeth: {
    request: true,
    methodList: []
  }
};
// 全局配置 Notice
// Vue.prototype.$Notice = config;
// {
//   config(options) {
//     options = {
//       top: 100,
//       duration: 3
//     };
//   }
// };
// until.phoneType()=='PC'?until.websiteAdaptive():until.adaptive()

Vue.config.productionTip = false;
Vue.use(iView, {
  i18n: (key, value) => i18n.t(key, value)
});

// 全局确认对话框
let modalCon = function(text) {
  return new Promise((resolve, reject) => {
    this.$Modal.confirm({
      title: this.$i18n.tc("views.public.prompt"),
      okText: this.$i18n.tc("views.public.sure"),
      cancelText: this.$i18n.tc("views.public.cancel"),
      content: text,
      onOk: () => {
        resolve(true);
      },
      onCancel: () => {
        resolve(false);
      }
    });
  });
};

// 获取权限设置
let getauth = function(id) {
  let list = JSON.parse(localStorage.getItem("authList")) || [];
  let data = false;
  list.forEach(item => {
    if (Number(item.id) == id) {
      data = item.detail_menu;
    }
  });
  return data;
};

Vue.prototype.$modalCon = modalCon;
Vue.prototype.getauth = getauth;
// Vue.prototype.deepClone = util.deepClone;

/* eslint-disable no-new */
// new Vue({
//   el: "#app",
//   router,
//   store,
//   i18n,
//   until,
//   components: { App },
//   template: "<App/>"
// });

if (process.env.NODE_ENV == "development") {
  // 测试环境
  new Vue({
    el: "#app",
    router,
    store,
    i18n,
    components: { App },
    template: "<App/>"
  });
} else {
  // 判断是否能打开页面
  const xhr = new XMLHttpRequest();
  //?block=1是测试模拟401错误
  let url = "https://short.faceline.live/cn"; // 'https://short.faceline.live/cn?block=1'  //
  xhr.open("GET", url);
  xhr.onload = () => {
    if (xhr.status === 200) {
      console.log("status200", xhr.responseText);
      // 成功后new Vue
      new Vue({
        el: "#app",
        router,
        store,
        i18n,
        components: { App },
        template: "<App/>"
      });
    } else {
      console.log("error");
      location.href = "https://www.google.com";
    }
  };
  xhr.onerror = () => {
    location.href = "https://www.google.com";
  };
  xhr.send();
}



// WEBPACK FOOTER //
// ./src/main.js